import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/services/servicesData.json";

export default function Services() {
  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Оказание услуг гражданам в сфере здравоохранения
      </h1>

      <div>
        <h3 className="about-nii__title antiCorruption__title">Законы</h3>
        <Accordion data={data} />
      </div>
    </section>
  );
}
